// Single - post, case study, event, mandate

document.addEventListener("alpine:init", () => {
    Alpine.data("singlePart", () => ({
        visible: false,
        init() {},
    }));
});
